import { createDataSelectors } from "@app/modules/app.reducers";
import { Kpi } from "@ea/shared_types/types";

export const kpisDataSelectors = createDataSelectors<Kpi>()("kpis");
